import MainMapWrapper from '../../components/CountryComponent/ListViewLeftPart/MapComponent/MainMapWrapper';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(MainMapWrapper);
